<template>
  <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
    <div v-if="hasPermission('segmento-ensino-medio')" class="main pb-4" id="about-main">
      <b-container fluid="lg">
        <b-card no-body class="shadow-sm">
          <div class="p-2">
            <b-nav tabs fill>
              <b-nav-item link-classes="nav-books" @click="setActive(index)"
                :class="{ 'disabled': menu.id === 4, 'active': activeIndex === index }" :disabled="menu.id === 4"
                :active="activeIndex === index" v-for="(menu, index) in lists" :key="index">
                <i :class="menu.iconClass"></i>
                <span class="mr-auto">{{ menu.name }}</span>
              </b-nav-item>
            </b-nav>
          </div>
          
          <div v-for="(menu, index) in lists" :key="index">
            <b-collapse @show="setActive(index)" @hide="clearActive(index)" :visible="activeIndex === index">
              <div class="my-3" v-if="menu.turmas">
                <b-card v-for="(turma, idx) in menu.turmas" :key="idx" class="border-0 shadow-none" no-body>
                  <b-card-header header-bg-variant="transparent" class="py-0 border-0">
                    <b-button block @click="toggleCollapse('colecaoCpv', idx)" variant="link" class="button-toggle border-light p-3 text-decoration-none"
                      v-if="menu.name == 'Coleção CPV'">
                      <div class="d-flex align-items-center justify-content-baseline">
                        <span class="mr-auto"><strong>{{ turma.name }}</strong> <span v-if="turma.otherName != ''">- ({{
                          turma.otherName }})</span></span>
                        <i :class="collapsedStates.colecaoCpv[idx] ? 'fa-solid fa-minus' : 'fa-solid fa-plus'"></i>
                      </div>
                    </b-button>
                    <b-button block @click="toggleCollapse('manualCpv', idx)" variant="link" class="button-toggle border-light p-3 text-decoration-none"
                      v-if="menu.name == 'Manual'">
                      <div class="d-flex align-items-center justify-content-baseline">
                        <span class="mr-auto"><strong>{{ turma.name }}</strong> <span v-if="turma.otherName != ''">- ({{
                          turma.otherName }})</span></span>
                        <i :class="collapsedStates.manualCpv[idx] ? 'fa-solid fa-minus' : 'fa-solid fa-plus'"></i>
                      </div>
                    </b-button>
                    <b-button block @click="toggleCollapse('resolucaoCpv', idx)" variant="link" class="button-toggle border-light p-3 text-decoration-none"
                      v-if="menu.name == 'Resoluções'">
                      <div class="d-flex align-items-center justify-content-baseline">
                        <span class="mr-auto"><strong>{{ turma.name }}</strong> <span v-if="turma.otherName != ''">- ({{
                          turma.otherName }})</span></span>
                        <i :class="collapsedStates.resolucaoCpv[idx] ? 'fa-solid fa-minus' : 'fa-solid fa-plus'"></i>
                      </div>
                    </b-button>
                    <b-button block @click="toggleCollapse('exerciciosRegionais', idx)" variant="link" class="button-toggle border-light p-3 text-decoration-none"
                      v-if="menu.name == 'Exercícios Regionais'">
                      <div class="d-flex align-items-center justify-content-baseline">
                        <span class="mr-auto"><strong>{{ turma.name }}</strong> <span v-if="turma.otherName != ''">- ({{
                          turma.otherName }})</span></span>
                        <i
                          :class="collapsedStates.exerciciosRegionais[idx] ? 'fa-solid fa-minus' : 'fa-solid fa-plus'"></i>
                      </div>
                    </b-button>
                    <b-button block @click="toggleCollapse('aulaDigitalCpv', idx)" class="button-toggle p-3"
                      v-if="menu.name == 'A. Digital'">
                      <div class="d-flex align-items-center justify-content-baseline">
                        <span class="mr-auto"><strong>{{ turma.name }}</strong> <span v-if="turma.otherName != ''">- ({{
                          turma.otherName }})</span></span>
                        <i
                          :class="collapsedStates.aulaDigitalCpv[idx] ? 'fa-solid fa-minus' : 'fa-solid fa-plus'"></i>
                      </div>
                    </b-button>
                  </b-card-header>
                  <b-card-body class="py-0" v-if="menu.name == 'Coleção CPV'">
                    <b-collapse v-model="collapsedStates.colecaoCpv[idx]">
                      <b-card class="border border-light" no-body>
                        <b-card-header class="pb-0 border-bottom-0" header-bg-variant="transparent" v-if="getVisibleBooks(turma).length > 0">
                          <b-nav tabs fill small>
                            <b-nav-item link-classes="nav-cadernos" v-for="(book, idx) in getVisibleBooks(turma)" :key="idx" :active="activeTab === idx" @click="activeTab = idx">
                              <span>{{ book.bookName }}</span>
                            </b-nav-item>
                          </b-nav>
                        </b-card-header>
                        <b-card-body>
                          <div v-if="turma.books[activeTab]">
                            <div v-for="(apostila, index) in turma.books[activeTab].apostila" :key="index">
                              <router-link :to="{
                                name: 'render-conteudo-exclusivo',
                                params: { paramsForUrl: apostila.linkFree || '', nomeApostila: apostila.name || '' },
                                query: { material: formatParam(apostila.description) }
                              }">
                                <transition type="animation" enter-active-class="animated animate__fadeIn" leave-active-class="animated animate__fadeOut" appear mode="out-in">
                                  <b-card no-body class="p-3 text-dark">
                                    <div class="d-flex aling-items-center">
                                      <i :class="apostila.iconClass" class="d-flex align-items-center"></i>
                                      <span v-if="apostila.book" class="mr-2"><strong>{{ apostila.book }}</strong></span> <span v-if="apostila.book">-</span><span class="ml-2">{{ apostila.name }}</span>
                                    </div>
                                  </b-card>
                                </transition>
                              </router-link>
                            </div>
                          </div>    
                        </b-card-body>
                      </b-card>
                    </b-collapse>
                  </b-card-body>
                  <b-card-body class="py-0" v-if="menu.name == 'Manual'">
                    <b-collapse v-model="collapsedStates.manualCpv[idx]">
                      <b-card class="border border-light" no-body>
                        <b-card-body>
                          <div v-for="(apostila, index) in turma.books" :key="index">
                            <router-link :to="{
                              name: 'render-conteudo-exclusivo',
                              params: { paramsForUrl: apostila.linkFree || '', nomeApostila: apostila.name || '' },
                              query: { material: formatParam(apostila.description) }
                            }">
                              <transition type="animation" enter-active-class="animated animate__fadeIn" leave-active-class="animated animate__fadeOut" appear mode="out-in">
                                <b-card no-body class="p-3 text-dark">
                                  <div class="d-flex aling-items-center">
                                    <i :class="apostila.iconClass" class="d-flex align-items-center"></i>
                                    <span class="ml-2">{{ apostila.name }}</span>
                                  </div>
                                </b-card>
                              </transition>
                            </router-link>
                          </div> 
                        </b-card-body>    
                      </b-card>
                    </b-collapse>
                  </b-card-body>
                  <b-card-body class="py-0" v-if="menu.name == 'Resoluções'">
                    <b-collapse v-model="collapsedStates.resolucaoCpv[idx]">
                      <b-card class="p-2 border border-light" no-body>
                        <b-card-header class="pb-0 border-bottom-0" header-bg-variant="transparent" v-if="getVisibleBooks(turma).length > 0">
                          <b-nav tabs fill small>
                            <b-nav-item link-classes="nav-cadernos" v-for="(book, idx) in getVisibleBooks(turma)" :key="idx" :active="activeTab === idx" @click="activeTab = idx">
                              <span v-if="book.bookName">{{ book.bookName }}</span>
                            </b-nav-item>
                          </b-nav>
                        </b-card-header>
                        <b-card-body v-if="turma.books[activeTab]">
                          <div v-for="(apostila, index) in turma.books[activeTab].apostila" :key="index">
                            <router-link :to="{
                              name: 'render-conteudo-exclusivo',
                              params: { paramsForUrl: apostila.linkFree || '', nomeApostila: apostila.name || '' },
                              query: { material: formatParam(apostila.description) }
                            }">
                              <transition type="animation" enter-active-class="animated animate__fadeIn" leave-active-class="animated animate__fadeOut" appear mode="out-in">
                                <b-card no-body class="p-3 text-dark">
                                  <div class="d-flex aling-items-center">
                                    <i :class="apostila.iconClass" class="d-flex align-items-center"></i>
                                    <span class="ml-2">{{ apostila.name }}</span>
                                  </div>
                                </b-card>
                              </transition>
                            </router-link>
                          </div>
                        </b-card-body>
                      </b-card>
                    </b-collapse>
                  </b-card-body>
                  <b-card-body class="py-0" v-if="menu.name == 'Exercícios Regionais'">
                    <b-collapse v-model="collapsedStates.exerciciosRegionais[idx]">
                      <b-card class="border border-light" no-body>
                        <b-card-body>
                          <div v-for="(apostila, index) in turma.books" :key="index">
                            <router-link :to="{
                              name: 'render-conteudo-exclusivo',
                              params: { paramsForUrl: apostila.linkFree || '', nomeApostila: apostila.name || '' },
                              query: { material: formatParam(apostila.description) }
                            }">
                              <transition type="animation" enter-active-class="animated animate__fadeIn" leave-active-class="animated animate__fadeOut" appear mode="out-in">
                                <b-card no-body class="p-3 text-dark">
                                  <div class="d-flex aling-items-center">
                                    <i :class="apostila.iconClass" class="d-flex align-items-center"></i>
                                    <span class="ml-2">{{ apostila.name }}</span>
                                  </div>
                                </b-card>
                              </transition>
                            </router-link>
                          </div>    
                        </b-card-body> 
                      </b-card>
                    </b-collapse>
                  </b-card-body>
                </b-card>
              </div>
              <b-card no-body class="border-0 shadow-none py-2" v-else>
                <b-card-body class="py-1" v-for="(book, i) in menu.books" :key="i">
                  <router-link :to="{
                        name: 'render-conteudo-exclusivo',
                        params: { paramsForUrl: book.linkFree || '', nomeApostila: book.name || '' },
                        query: { material: formatParam(book.description) }
                      }">
                        <b-card no-body class="p-3 text-dark">
                          <div class="d-flex aling-items-center">
                            <i :class="book.iconClass" class="d-flex align-items-center"></i>
                            <span>{{ book.name }}</span>
                          </div>
                        </b-card>
                      </router-link>
                </b-card-body>
              </b-card>
            </b-collapse>
          </div>
        </b-card>
      </b-container>
    </div>
    <div v-else>
      <div class="container">
        <div class="text-center">
          {{ error503 }}
          <p>Você não tem permissão para visualizar este conteúdo.</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'dash-infantil',
  data() {
    return {
      pageTitle: 'ENSINO Médio',
      pageSubtitle: '',

      NamePermission: '',
      IndexPermission: '',

      activeIndex: 0,
      activeTab: 0,

      collapsedStates: {
        colecaoCpv: [],
        manualCpv: [],
        resolucaoCpv: [],
        exerciciosRegionais: [],
        caderno1: [], 
        caderno2: [], 
        caderno3: [], 
        caderno4: [], 
      },

      lists: [
        {
          id: 1,
          name: 'Coleção CPV',
          iconClass: 'fa-solid fa-book fa-sm mr-1',
          link_name: 'ensino-medio-colecao-cpv',
          colorCard: {
            'background-color': '#38aaf3',
            'border:': '1px solid #38aaf3',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-ensino-medio',
          bg__link: 'infantil',
          turmas: [
            {
              name: '1ª Série',
              otherName: '',
              permission: 'segmento-ensino-medio',
              books: [
                {
                  bookName: 'Caderno 1',
                  apostila: [
                  {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/1-serie/caderno-1/EM_FGB_1a_Serie_Caderno_1.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 1',
                      name: 'Formação Geral Básica',
                      segment: '1',
                      discipline: '',
                      description: '1º Ano - Caderno - 1',
                      toolTip: ' ',
                      isbn: 'ISBN: 978-85-86203-59-6',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/1-serie/caderno-1/EM_IFC_1a_Serie_Caderno_1.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 1',
                      name: 'Itinerário Formativo Comum',
                      segment: '1',
                      discipline: '',
                      description: '1º Ano - Caderno - 2',
                      toolTip: ' ',
                      isbn: '',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/1-serie/caderno-1/EM_IFO_1a_Serie_Caderno_1.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 1',
                      name: 'Itinerário Formativo Optativo',
                      segment: '1',
                      discipline: '',
                      description: '1º Ano - Caderno - 3',
                      toolTip: ' ',
                      isbn: '',
                    },
                  ]
                },
                {
                  bookName: 'Caderno 2',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/1-serie/caderno-2/EM_FGB_1a_Serie_Caderno_2.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 2',
                      name: 'Formação Geral Básica',
                      segment: '1',
                      discipline: '',
                      description: '1º Ano - Caderno - 1',
                      toolTip: ' ',
                      isbn: 'ISBN: 978-85-86203-59-6',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/1-serie/caderno-2/EM_IFC_1a_Serie_Caderno_2.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 2',
                      name: 'Itinerário Formativo Comum',
                      segment: '1',
                      discipline: '',
                      description: '1º Ano - Caderno - 2',
                      toolTip: ' ',
                      isbn: '',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/1-serie/caderno-2/EM_IFO_1a_Serie_Caderno_2.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 2',
                      name: 'Itinerário Formativo Optativo',
                      segment: '1',
                      discipline: '',
                      description: '1º Ano - Caderno - 4',
                      toolTip: ' ',
                      isbn: '',
                    },
                  ]
                },
                {
                  bookName: 'Caderno 3',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/1-serie/caderno-3/EM_FGB_1a_Serie_Caderno_3.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 3',
                      name: 'Formação Geral Básica',
                      segment: '1',
                      discipline: '',
                      description: '1º Ano - Caderno - 1',
                      toolTip: ' ',
                      isbn: 'ISBN: 978-85-86203-59-6',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/1-serie/caderno-3/EM_IFC_1a_Serie_Caderno_3.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 3',
                      name: 'Itinerário Formativo Comum',
                      segment: '1',
                      discipline: '',
                      description: '1º Ano - Caderno - 3',
                      toolTip: ' ',
                      isbn: '',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/1-serie/caderno-3/EM_IFO_1a_Serie_Caderno_3.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 3',
                      name: 'Itinerário Formativo Optativo',
                      segment: '1',
                      discipline: '',
                      description: '1º Ano - Caderno - 4',
                      toolTip: ' ',
                      isbn: '',
                    },
                  ]
                },
                {
                  bookName: 'Caderno 4',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/1-serie/caderno-4/EM_FGB_1a_Serie_Caderno_4.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 4',
                      name: 'Formação Geral Básica',
                      segment: '1',
                      discipline: '',
                      description: '1º Ano - Caderno - 2',
                      toolTip: ' ',
                      isbn: '',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/1-serie/caderno-4/EM_IFC_1a_Serie_Caderno_4.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 4',
                      name: 'Itinerário Formativo Comum',
                      segment: '1',
                      discipline: '',
                      description: '1º Ano - Caderno - 3',
                      toolTip: ' ',
                      isbn: '',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/1-serie/caderno-4/EM_IFO_1a_Serie_Caderno_4.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 4',
                      name: 'Itinerário Formativo Optativo',
                      segment: '1',
                      discipline: '',
                      description: '1º Ano - Caderno - 4',
                      toolTip: ' ',
                      isbn: '',
                    },
                  ]
                },
              ]
            },
            {
              name: '2ª Série',
              otherName: '',
              permission: 'segmento-ensino-medio',
              books: [
                {
                  bookName: 'Caderno 5',
                  apostila: [
                  {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/2-serie/caderno-5/EM_FGB_2a_Serie_Caderno_5.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 5',
                      name: 'Formação Geral Básica',
                      segment: '1',
                      discipline: '',
                      description: '2o_Ano_Caderno_5_Formacao_Geral_Basica',
                      toolTip: ' ',
                      isbn: 'ISBN: 978-85-86203-59-6',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/2-serie/caderno-5/EM_IFC_2a_Serie_Caderno_5.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 5',
                      name: 'Itinerário Formativo Comum',
                      segment: '1',
                      discipline: '',
                      description: '2o_Ano_Caderno_5_Itinerario_Formativo_Comum',
                      toolTip: ' ',
                      isbn: '',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/2-serie/caderno-5/EM_IFO_2a_Serie_Caderno_5.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 5',
                      name: 'Itinerário Formativo Optativo',
                      segment: '1',
                      discipline: '',
                      description: '2o_Ano_Caderno_5_Itinerario_Formativo_Optativo',
                      toolTip: ' ',
                      isbn: '',
                    },
                  ]
                },
                {
                  bookName: 'Caderno 6',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/2-serie/caderno-6/EM_FGB_2a_Serie_Caderno_6.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 6',
                      name: 'Formação Geral Básica',
                      segment: '1',
                      discipline: '',
                      description: '2o_Ano_Caderno_6_Formacao_Geral_Basica',
                      toolTip: ' ',
                      isbn: 'ISBN: 978-85-86203-59-6',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/2-serie/caderno-6/EM_IFC_2a_Serie_Caderno_6.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 6',
                      name: 'Itinerário Formativo Comum',
                      segment: '1',
                      discipline: '',
                      description: '2o_Ano_Caderno_6_Itinerario_Formativo_Comum',
                      toolTip: ' ',
                      isbn: '',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:'ensino-medio/colecao-cpv/2-serie/caderno-6/EM_IFO_2a_Serie_Caderno_6.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 6',
                      name: 'Itinerário Formativo Optativo',
                      segment: '1',
                      discipline: '',
                      description: '2o_Ano_Caderno_6_Itinerario_Formativo_Optativo',
                      toolTip: ' ',
                      isbn: '',
                    },
                  ]
                },
                {
                  bookName: 'Caderno 7',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/3-serie/caderno-7/EM_FGB_2a_Serie_Caderno_7.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 7',
                      name: 'Formação Geral Básica',
                      segment: '1',
                      discipline: '',
                      description: '2o_Ano_Caderno_7_Formacao_Geral_Basica',
                      toolTip: ' ',
                      isbn: 'ISBN: 978-85-86203-59-6',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/2-serie/caderno-7/EM_IFC_2a_Serie_Caderno_7.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 7',
                      name: 'Itinerário Formativo Comum',
                      segment: '1',
                      discipline: '',
                      description: '2o_Ano_Caderno_7_Itinerario_Formativo_Comum',
                      toolTip: ' ',
                      isbn: '',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/2-serie/caderno-7/EM_IFO_2a_Serie_Caderno_7.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 7',
                      name: 'Itinerário Formativo Optativo',
                      segment: '1',
                      discipline: '',
                      description: '2o_Ano_Caderno_7_Itinerario_Formativo_Optativo',
                      toolTip: ' ',
                      isbn: '',
                    },
                  ]
                },
                {
                  bookName: 'Caderno 8',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/2-serie/caderno-8/EM_FGB_2a_Serie_Caderno_8.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 8',
                      name: 'Formação Geral Básica',
                      segment: '1',
                      discipline: '',
                      description: '2o_Ano_Caderno_8_Formacao_Geral_Basica',
                      toolTip: ' ',
                      isbn: '',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/2-serie/caderno-8/EM_IFC_2a_Serie_Caderno_8.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 8',
                      name: 'Itinerário Formativo Comum',
                      segment: '1',
                      discipline: '',
                      description: '12o_Ano_Caderno_8_Itinerario_Formativo_Comum',
                      toolTip: ' ',
                      isbn: '',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/2-serie/caderno-8/EM_IFO_2a_Serie_Caderno_8.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 8',
                      name: 'Itinerário Formativo Optativo',
                      segment: '1',
                      discipline: '',
                      description: '2o_Ano_Caderno_8_Itinerario_Formativo_Optativo',
                      toolTip: ' ',
                      isbn: '',
                    },
                  ]
                },
              ]
            },
            {
              name: '3º Série',
              otherName: '',
              permission: 'segmento-ensino-medio',
              books: [
                {
                  bookName: 'Caderno 9',
                  apostila: [
                  {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/3-serie/caderno-9/EM_FGB_3a_Serie_Caderno_9.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 9',
                      name: 'Formação Geral Básica',
                      segment: '1',
                      discipline: '',
                      description: '3o_Ano_Caderno_9_Formacao_Geral_Basica',
                      toolTip: ' ',
                      isbn: 'ISBN: 978-85-86203-59-6',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/3-serie/caderno-9/EM_IFC_3a_Serie_Caderno_9.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 9',
                      name: 'Itinerário Formativo Comum',
                      segment: '1',
                      discipline: '',
                      description: '3o_Ano_Caderno_9_Itinerario_Formativo_Comum',
                      toolTip: ' ',
                      isbn: '',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/3-serie/caderno-9/EM_IFO_3a_Serie_Caderno_9.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 9',
                      name: 'Itinerário Formativo Optativo',
                      segment: '1',
                      discipline: '',
                      description: '3o_Ano_Caderno_9_Itinerario_Formativo_Optativo',
                      toolTip: ' ',
                      isbn: '',
                    },
                  ]
                },
                {
                  bookName: 'Caderno 10',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/3-serie/caderno-10/EM_FGB_3a_Serie_Caderno_10.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 10',
                      name: 'Formação Geral Básica',
                      segment: '1',
                      discipline: '',
                      description: '3o_Ano_Caderno_10_Formacao_Geral_Basica',
                      toolTip: ' ',
                      isbn: 'ISBN: 978-85-86203-59-6',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/3-serie/caderno-10/EM_IFC_3a_Serie_Caderno_10.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 10',
                      name: 'Itinerário Formativo Comum',
                      segment: '1',
                      discipline: '',
                      description: '3o_Ano_Caderno_10_Itinerario_Formativo_Comum',
                      toolTip: ' ',
                      isbn: '',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:'ensino-medio/colecao-cpv/3-serie/caderno-10/EM_IFO_3a_Serie_Caderno_10.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-cad-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 10',
                      name: 'Itinerário Formativo Optativo',
                      segment: '1',
                      discipline: '',
                      description: '3o_Ano_Caderno_10_Itinerario_Formativo_Optativo',
                      toolTip: ' ',
                      isbn: '',
                    },
                  ]
                },
              ]
            },
            {
              name: 'Material Complementar ',
              otherName: '',
              permission: 'segmento-ensino-medio',
              books: [
                {
                  bookName: 'História da Arte',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/materiais-complementares/historia-da-arte-_-em-_-1_serie.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-comp-arte-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 1',
                      name: 'História da Arte',
                      segment: '1, mc',
                      discipline: 'Artes',
                      description: 'História da Arte - 1ª Série',
                      toolTip: ' ',
                      isbn: 'Material Complementar',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/materiais-complementares/historia-da-arte-_-em-_-2_serie.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-comp-arte-2.png',
                      bundle: 'E_medio',
                      book: 'Caderno 2', 
                      name: 'História da Arte',
                      segment: '2, mc',
                      discipline: 'Artes',
                      description: 'História da Arte - 2ª Série',
                      toolTip: ' ',
                      isbn: 'Material Complementar',
                    },

                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/materiais-complementares/historia-da-arte-_-em-_-3_serie.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-comp-arte-3.png',
                      bundle: 'E_medio',
                      book: 'Caderno 3',
                      name: 'História da Arte',
                      segment: '3, mc',
                      discipline: 'Artes',
                      description: 'História da Arte - 3ª Série',
                      toolTip: ' ',
                      isbn: 'Material Complementar',
                    },
                  ]
                },
                {
                  bookName: 'Inglês',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/materiais-complementares/ingles-_-em-_-1_serie.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-comp-english-1.png',
                      bundle: 'E_medio',
                      book: 'Caderno 1',
                      name: 'Inglês',
                      segment: '1, mc',
                      discipline: '',
                      description: 'Língua Inglesa- 1ª Série',
                      toolTip: ' ',
                      isbn: 'Material Complementar',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/materiais-complementares/ingles-_-em-_2-serie.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-comp-english-2.png',
                      bundle: 'E_medio',
                      book: 'Caderno 2',
                      name: 'Inglês',
                      segment: '2, mc',
                      discipline: 'Língua Inglesa',
                      description: 'Língua Inglesa- 2ª Série',
                      toolTip: ' ',
                      isbn: 'Material Complementar',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/colecao-cpv/materiais-complementares/ingles-_-em-_3_serie.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-comp-english-3.png',
                      bundle: 'E_medio',
                      book: 'Caderno 3',
                      name: 'Inglês',
                      segment: '3, mc',
                      discipline: 'Língua Inglesa',
                      description: 'Língua Inglesa- 3ª Série',
                      toolTip: ' ',
                      isbn: 'Material Complementar',
                    },
                  ]
                },
              ]
            },
          ],
        },
        {
          id: 2,
          name: 'Programação',
          iconClass: 'fa-solid fa-calendar-days fa-sm mr-1',
          link_name: 'ensino-medio-programacao',
          colorCard: {
            'background-color': '#4ac8aa',
            'border:': '1px solid #4ac8aa',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-ensino-medio',
          bg__link: 'fundamental-i',
          books: [
            {
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkReaOnly: '',
              linkFree: 'ensino-medio/programacao/Programacao _ EM _ 2024.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
              bundle: 'E_medio',
              name: 'Programação Base - Ensino Médio',
              segment: 'all',
              discipline: '',
              description: 'Ensino Médio - Proposta Pedagógica e Programação',
              toolTip: ' ',
              isbn: 'Programação ',
            },
            {
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkReaOnly: '',
              linkFree:
                'ensino-medio/programacao/programacao-em-espanhol.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
              bundle: 'E_medio',
              name: 'Programação - Ensino Médio - Espanhol',
              segment: 'all',
              discipline: '',
              description: 'Ensino Médio - Proposta Pedagógica e Programação - Espanhol',
              toolTip: ' ',
              isbn: 'Programação ',
            },
          ]
        },
        {
          id: 3,
          name: 'Manual',
          iconClass: 'fa-solid fa-notebook fa-sm mr-1',
          link_name: 'ensino-medio-manual',
          colorCard: {
            'background-color': '#a7dc48',
            'border:': '1px solid #a7dc48',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-ensino-medio',
          bg__link: 'fundamental-ii',
          turmas: [
            {
              name: '1º Ano',
              otherName: '',
              permission: 'segmento-ensino-medio',
              books: [
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/1-serie/CadProf%20_%20EM%20_%20LP%20_%201S%20_%20Cadernos%201%20a%204%20_%20Formacao%20Geral%20Basica.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual.png',
                  bundle: 'E_medio',
                  name: 'Formação Geral Básica - Língua Portuguesa - 1ª Série',
                  segment: '1',
                  discipline: 'Língua Portuguesa',
                  description: 'caderno do professor lingua portuguesa',
                  toolTip: '',
                  isbn: 'Itinerário Formativo Comum',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/1-serie/CadProf%20_%20EM%20_%20MAT%20Algebra%20_%201S%20_%20Cadernos%201%20a%204%20_%20Formacao%20Geral%20Basica.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual.png',
                  bundle: 'E_medio',
                  name: 'Formação Geral Básica - Álgebra - 1ª Série',
                  segment: '1',
                  discipline: 'Álgebra',
                  description: 'caderno do professor algebra',
                  toolTip: '',
                  isbn: 'Formação Geral Básica',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/1-serie/CadProf%20_%20EM%20_%20GEO%20_%201S%20_%20Cadernos%201%20a%204%20_%20Formacao%20Geral%20Basica.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual.png',
                  bundle: 'E_medio',
                  name: 'Formação Geral Básica - Geografia - 1ª Série',
                  segment: '1',
                  discipline: 'Goegrafia',
                  description: 'caderno do professor geografia',
                  toolTip: '',
                  isbn: 'Formação Geral Básica',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/1-serie/CadProf%20_%20EM%20_%20HIS%20_%201S%20_%20Cadernos%201%20a%204%20_%20Formacao%20Geral%20Basica.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual.png',
                  bundle: 'E_medio',
                  name: 'Formação Geral Básica - História - 1ª Série',
                  segment: '1',
                  discipline: 'História',
                  description: 'caderno do professor historia',
                  toolTip: '',
                  isbn: 'Formação Geral Básica',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/1-serie/CadProf%20_%20EM%20_%20QUI%20_%201S%20_%20Cadernos%201%20a%204%20_%20Formacao%20Geral%20Basica.pdf ',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual.png',
                  bundle: 'E_medio',
                  name: 'Formação Geral Básica - Química - 1ª Série',
                  segment: '1',
                  discipline: 'Química',
                  description: 'caderno do professor quimica',
                  toolTip: '',
                  isbn: 'Formação Geral Básica',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/1-serie/Cad%20Prof%20_%20EM%20_%20Fisica%20_%201S%20_%20cads%201%20a%204%20_%20Itinerario%20Formativo%20Optativo%20-%20Estudos%20Avancados%203.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual.png',
                  bundle: 'E_medio',
                  name: ' Formação Geral Básica - Física | ENEM - 1ª Série',
                  segment: '1, Enem',
                  discipline: 'Física',
                  description: 'caderno do professor fisica',
                  toolTip: '',
                  isbn: 'Estudos Avançados',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/1-serie/CadProf%20_%20EM%20_%20BIO%20_%201S%20_%20Cadernos%201%20a%204%20_%20Formacao%20Geral%20Basica.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual.png',
                  bundle: 'E_medio',
                  name: 'Formação Geral Básica - Biologia - 1ª Série',
                  segment: '1',
                  discipline: 'Biologia',
                  description: 'caderno do professor biologia',
                  toolTip: '',
                  isbn: 'Formação Geral Básica',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/1-serie/Cad%20Prof%20_%20EM%20_%20Biologia_%201S%20_%20cads%201%20a%204%20_%20Itinerario%20Formativo%20Optativo%20-%20Estudos%20Avancados%203.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual.png',
                  bundle: 'E_medio',
                  name: 'Formação Geral Básica - Biologia | ENEM - 1ª Série',
                  segment: '1, Enem',
                  discipline: 'Biologia',
                  description: 'caderno do professor biologia enem',
                  toolTip: '',
                  isbn: 'Estudos Avançados',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/1-serie/Cad%20Prof%20_%20EM%20_%20Filosofia%20_%201S%20_%20cads%201%20a%204%20_%20Itinerario%20Formativo%20Optativo%20-%20Estudos%20Avancados%203.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual.png',
                  bundle: 'E_medio',
                  name: 'Itnerário Formativo Optativo - Filosofia - 1ª Série',
                  segment: '1',
                  discipline: 'Filosofia',
                  description: 'caderno do professor filosofia',
                  toolTip: '',
                  isbn: 'Estudos Avançados',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/1-serie/Cad%20Prof%20_%20EM%20_%20Quimica%20_%201S%20_%20cads%201%20a%204%20_%20Itinerario%20Formativo%20Optativo%20-%20Estudos%20Avancados%203.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual.png',
                  bundle: 'E_medio',
                  name: 'Itnerário Formativo Optativo - Química | ENEM - 1ª Série',
                  segment: '1, Enem',
                  discipline: 'Química',
                  description: 'caderno do professor quimica enem',
                  toolTip: '',
                  isbn: 'Estudos Avançados',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/1-serie/CadProf%20_%20EM%20_%20FIS%20_%201S%20_%20Cadernos%201%20a%204%20_%20Formacao%20Geral%20Basica.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual.png',
                  bundle: 'E_medio',
                  name: 'Itnerário Formativo Optativo - fiscol01-R_ 1ª Série',
                  segment: '1',
                  discipline: 'Física',
                  description: 'caderno do professor fisica',
                  toolTip: '',
                  isbn: 'Formação Geral Básica',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/1-serie/Cad Prof _ EM _ Sociologia _ 1S _ cads 1 a 4 _ Itinerario Formativo Optativo - Estudos Avancados 3.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual.png',
                  bundle: 'E_medio',
                  name: 'Itnerário Formativo Optativo - Sociologia - 1ª Série',
                  segment: '1',
                  discipline: 'Sociologia',
                  description: 'caderno do professor sociologia',
                  toolTip: '',
                  isbn: 'Estudos Avançados',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/1-serie/CadProf%20_%20EM%20_%20MAT%20Geometria%20_%201S%20_%20Cadernos%201%20a%204%20_%20Itinerario%20Formativo%20Comum.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual.png',
                  bundle: 'E_medio',
                  name: 'Itnerário Formativo Comum - Geometria - 1ª Série',
                  segment: '1',
                  discipline: 'Geometria',
                  description: 'caderno do professor geometria',
                  toolTip: '',
                  isbn: 'Itinerário Formativo Comum',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/1-serie/CadProf%20_%20EM%20_%20HIST%20ARTE%20_%201S%20_%20Cadernos%201%20a%204%20_%20Itinerario%20Formativo%20Comum.pdf ',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual.png',
                  bundle: 'E_medio',
                  name: 'Itnerário Formativo Comum - História da Arte - 1ª Série',
                  segment: '1',
                  discipline: 'Artes, História',
                  description: 'caderno do professor historia da arte',
                  toolTip: '',
                  isbn: 'Itinerário Formativo Comum',
                },

                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/1-serie/CadProf%20_%20EM%20_%20LIT%20_%201S%20_%20Cadernos%201%20a%204%20_%20Itinerario%20Formativo%20Comum.pdf ',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual.png',
                  bundle: 'E_medio',
                  name: 'Itnenário Formativo Comum - Literatura - 1ª Série',
                  segment: '1',
                  discipline: 'Literatura',
                  description: 'caderno do professor literatura',
                  toolTip: '',
                  isbn: 'Itinerário Formativo Comum',
                },
              ]
            },
            {
              name: '2º Ano',
              otherName: '',
              permission: 'segmento-ensino-medio',
              books: [
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree: 'ensino-medio/manual/2-serie/manual-coodenador.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-manual-coordenador.png',
                  bundle: 'E_medio',
                  name: 'Manual de Orientações para o Coordenador',
                  segment: '1,2,3',
                  discipline: '',
                  description: 'manual de orientacoes para o coordenador',
                  toolTip: '',
                  isbn: 'Manual',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/2-serie/Manual-Educacao-Fisica-EM.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor_3.png',
                  bundle: 'E_medio',
                  name: 'Manual de Orientações - Educação Física',
                  segment: '1,2,3',
                  discipline: '',
                  description: 'manual de orientações educacao fisica',
                  toolTip: '',
                  isbn: 'Manual',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/2-serie/cadprof-_-em-_-2a-serie-_-bio-_-web.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - Biologia',
                  segment: '2',
                  discipline: 'Biologia',
                  description: 'caderno do professor biologia',
                  toolTip: '',
                  isbn: 'Caderno 5',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/2-serie/cadprof-_-espanhol-_-caderno-2-1.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - Espanhol',
                  segment: '2',
                  discipline: 'Língua Espanhola',
                  description: 'caderno do professor espanhol',
                  toolTip: '',
                  isbn: 'Caderno 2',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/2-serie/cadprof-_-em-_-filosofia-_-caderno-2.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - Filosofia',
                  segment: '2',
                  discipline: 'Filosofia',
                  description: 'caderno do professor filosofia',
                  toolTip: '',
                  isbn: 'Caderno 2',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/2-serie/cadprof-_-em-_-2a-serie-_-fisica-_-web.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - Física',
                  segment: '2',
                  discipline: 'Física',
                  description: 'caderno do professor fisica',
                  toolTip: '',
                  isbn: 'Caderno 5',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/2-serie/cadprof-_-em-_-2a-serie-_-geo-_-web.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - Geografia',
                  segment: '2',
                  discipline: 'Geografia',
                  description: 'caderno do professor geografia',
                  toolTip: '',
                  isbn: 'Caderno 5',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/2-serie/cadprof-_-em-_-2a-serie-_-his-_-web.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - História',
                  segment: '2',
                  discipline: 'História',
                  description: 'caderno do professor historia',
                  toolTip: '',
                  isbn: 'Caderno 5',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/2-serie/cad-prof-_-em-_-historia-da-arte-_-caderno-2.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - História da Arte',
                  segment: '2',
                  discipline: 'Artes, História',
                  description: 'caderno do professor historia da arte',
                  toolTip: '',
                  isbn: 'Caderno 2',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/2-serie/cadprof-_-em-_-ingles-_2_serie.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - Inglês',
                  segment: '2',
                  discipline: 'Língua Inglesa',
                  description: 'caderno do professor ingles',
                  toolTip: '',
                  isbn: 'Caderno 2',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/2-serie/cadprof-_-em-_-2a-serie-_-lp-_-web.pdf',
                  videoId: '',
                  src: 'ensino-medio/manual/2-serie/ase-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - Língua Portuguesa',
                  segment: '2',
                  discipline: 'Língua Portuguesa',
                  description: 'caderno do professor lingua portuguesa',
                  toolTip: '',
                  isbn: 'Caderno 5',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/2-serie/cadprof-_-em-_-2a-serie-_-lit-_-web.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - Literatura',
                  segment: '2',
                  discipline: 'Literatura',
                  description: 'caderno do professor literatura',
                  toolTip: '',
                  isbn: 'Caderno 5',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/2-serie/cadprof-_-em-_-2a-serie-_-mat-_-web.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - Matemática',
                  segment: '2',
                  discipline: 'Matemática',
                  description: 'caderno do professor matematica',
                  toolTip: '',
                  isbn: 'Caderno 5',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/2-serie/cadprof-_-em-_-2a-serie-_-qui-_-web.pdf',
                  videoId: '',
                  src: 'ensino-medio/manual/2-serie/base-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - Química',
                  segment: '2',
                  discipline: 'Química',
                  description: 'caderno do professor quimica',
                  toolTip: '',
                  isbn: 'Caderno 5',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/2-serie/cadprof-_-em-_-2a-serie-_-red-_-web.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - Redação',
                  segment: '2',
                  discipline: 'Redação',
                  description: 'caderno do professor redacao',
                  toolTip: '',
                  isbn: 'Caderno 5',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/2-serie/cadprof-_-em-_-sociologia-_-caderno-2.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - Sociologia',
                  segment: '2',
                  discipline: 'Sociologia',
                  description: 'caderno do professor sociologia',
                  toolTip: '',
                  isbn: 'Caderno 2',
                },
              ]
            },
            {
              name: '3º Ano',
              otherName: '',
              permission: 'segmento-ensino-medio',
              books: [
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree: 'ensino-medio/manual/3-serie/manual-coodenador.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-manual-coordenador.png',
                  bundle: 'E_medio',
                  name: 'Manual de Orientações para o Coordenador',
                  segment: '1,2,3',
                  discipline: '',
                  description: 'manual de orientações para o coordenador',
                  toolTip: '',
                  isbn: 'Manual',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/3-serie/Manual-Educacao-Fisica-EM.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/tbw_manual_professor_3.png',
                  bundle: 'E_medio',
                  name: 'Manual de Orientações - Educação Física',
                  segment: '1,2,3',
                  discipline: '',
                  description: 'manual de orientações educacao fisica',
                  toolTip: '',
                  isbn: 'Manual',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/3-serie/cadprof-_-em-_-3a-serie-_-bio-_-web.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - Biologia',
                  segment: '2',
                  discipline: 'Biologia',
                  description: 'caderno do professor biologia',
                  toolTip: '',
                  isbn: 'Caderno 5',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/3-serie/cadprof-_-espanhol-_-caderno-3-1.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - Espanhol',
                  segment: '2',
                  discipline: 'Língua Espanhola',
                  description: 'caderno do professor espanhol',
                  toolTip: '',
                  isbn: 'Caderno 2',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/3-serie/cadprof-_-em-_-filosofia-_-caderno-3.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - Filosofia',
                  segment: '2',
                  discipline: 'Filosofia',
                  description: 'caderno do professor filosofia',
                  toolTip: '',
                  isbn: 'Caderno 2',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/3-serie/cadprof-_-em-_-3a-serie-_-fisica-_-web.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - Física',
                  segment: '2',
                  discipline: 'Física',
                  description: 'caderno do professor fisica',
                  toolTip: '',
                  isbn: 'Caderno 5',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/3-serie/cadprof-_-em-_-3a-serie-_-geo-_-web.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - Geografia',
                  segment: '2',
                  discipline: 'Geografia',
                  description: 'caderno do professor geografia',
                  toolTip: '',
                  isbn: 'Caderno 5',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/3-serie/cadprof-_-em-_-3a-serie-_-his-_-web.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - História',
                  segment: '2',
                  discipline: 'História',
                  description: 'caderno do professor historia',
                  toolTip: '',
                  isbn: 'Caderno 5',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/3-serie/cad-prof-_-em-_-historia-da-arte-_-caderno-3.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - História da Arte',
                  segment: '2',
                  discipline: 'Artes, História',
                  description: 'caderno do professor historia da arte',
                  toolTip: '',
                  isbn: 'Caderno 2',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/3-serie/cadprof-_-em-_-ingles-_3_serie.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - Inglês',
                  segment: '2',
                  discipline: 'Língua Inglesa',
                  description: 'caderno do professor ingles',
                  toolTip: '',
                  isbn: 'Caderno 2',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/3-serie/cadprof-_-em-_-3a-serie-_-lp-_-web.pdf',
                  videoId: '',
                  src: 'ensino-medio/manual/3-serie/ase-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - Língua Portuguesa',
                  segment: '2',
                  discipline: 'Língua Portuguesa',
                  description: 'caderno do professor lingua portuguesa',
                  toolTip: '',
                  isbn: 'Caderno 5',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/3-serie/cadprof-_-em-_-3a-serie-_-lit-_-web.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - Literatura',
                  segment: '2',
                  discipline: 'Literatura',
                  description: 'caderno do professor literatura',
                  toolTip: '',
                  isbn: 'Caderno 5',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/3-serie/cadprof-_-em-_-3a-serie-_-mat-_-web.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - Matemática',
                  segment: '2',
                  discipline: 'Matemática',
                  description: 'caderno do professor matematica',
                  toolTip: '',
                  isbn: 'Caderno 5',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/3-serie/cadprof-_-em-_-3a-serie-_-qui-_-web.pdf',
                  videoId: '',
                  src: 'ensino-medio/manual/3-serie/base-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - Química',
                  segment: '2',
                  discipline: 'Química',
                  description: 'caderno do professor quimica',
                  toolTip: '',
                  isbn: 'Caderno 5',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/3-serie/cadprof-_-em-_-3a-serie-_-red-_-web.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - Redação',
                  segment: '2',
                  discipline: 'Redação',
                  description: 'caderno do professor redacao',
                  toolTip: '',
                  isbn: 'Caderno 5',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/manual/3-serie/cadprof-_-em-_-sociologia-_-caderno-3.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/manual/base-ensino-medio-manual-2.png',
                  bundle: 'E_medio',
                  name: 'Caderno do Professor - Sociologia',
                  segment: '2',
                  discipline: 'Sociologia',
                  description: 'caderno do professor sociologia',
                  toolTip: '',
                  isbn: 'Caderno 2',
                },
              ]
            },
          ],
        },
        /* 
        *******************************************************************************
        ** Obs.: Alexandre Chumer pediu para o pessoal da Editora atualizar o Layout. *
        *******************************************************************************
        {
            id: 4,
            name: 'Aulas Digitais',
            iconClass: 'fa-solid fa-desktop fa-sm mr-1',
            link_name: 'ensino-medio-aula-digital',
            colorCard: {
                'background-color': '#fc5b5b',
                'border:': '1px solid #fc5b5b',
                'border-radius': '0.5rem',
            },
            permission: 'segmento-ensino-medio',
            bg__link: 'medio',
        },
        */
        {
          id: 4,
          name: 'Aulas Digitais',
          iconClass: 'fa-solid fa-desktop fa-sm mr-1',
          link_name: 'maintenance',    // chama a página de Manutenção para o caso acima
          colorCard: {
            'background-color': '#fc5b5b',
            'border:': '1px solid #fc5b5b',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-ensino-medio',
          bg__link: 'medio',
        },
        {
          id: 5,
          name: 'Resoluções',
          iconClass: 'fa-solid fa-file-circle-check fa-sm mr-1',
          link_name: 'ensino-medio-resolucoes',
          colorCard: {
            'background-color': '#f7b03d',
            'border:': '1px solid #f7b03d',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-ensino-medio',
          bg__link: 'enem',
          turmas: [
            {
              name: 'Matemática',
              otherName: '',
              permission: 'segmento-ensino-medio',
              books: [
                {
                  bookName: 'Caderno 1',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-1/matcol13-r-_-geometria-plana.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol13-R_ Geometria Plana',
                      book_num: 'Caderno 1',
                      segment: '',
                      discipline: 'Geometria',
                      description: 'matcol13-R_ geometria plana',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '1',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-1/matcol14-r-_-geometria-plana.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol14-R_ Geometria Plana',
                      book_num: 'Caderno 1',
                      segment: '',
                      discipline: 'Geometria',
                      description: 'matcol14-R_ geometria plana',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno 1 <b-badge variant="light">1</b-badge>',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-1/matfun01-r-_-teoria-dos-conjuntos.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matfun01-R_ Teoria dos Conjuntos',
                      book_num: 'Caderno 1',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matfun01-R_ teoria dos conjuntos',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '1',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/matematica/caderno-1/matfun02-r-_-conjuntos-numericos.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matfun02-R_ Conjuntos Numéricos',
                      book_num: 'Caderno 1',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matfun02-R_ conjuntos numericos',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '1',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-1/matfun03-r-_-potenciacao-e-radiciacao.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matfun03-R_ Potenciação e Radiciação',
                      book_num: 'Caderno 1',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matfun03-R_ potenciacao e radiciacao',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '1',
                    },
                  ]
                },
                {
                  bookName: 'Caderno 2',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-2/matcol01-r-_-equacoes-do-1o-grau.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol01-R_ Equações do 1º Grau',
                      book_num: 'Caderno 2',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol01-R_ equacoes do 1o grau',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '2',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-2/matcol15-r-_-geometria-plana.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol15-R_ Geometria Plana',
                      book_num: 'Caderno 2',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol15-R_ geometria plana',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '2',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-2/matfun04-r-_-expressoes-algebricas.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matfun04-R_ Expressões Algébricas',
                      book_num: 'Caderno 2',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matfun04-R_ expressoes algebricas',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '2',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-2/matfun05-r-_-razao-e-proporcao.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matfun05-R_ Razão e Proporção',
                      book_num: 'Caderno 2',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matfun05-R_ razao e proporcao',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '2',
                    },
                  ],
                },
                {
                  bookName: 'Caderno 3',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-3/matcol02-r-_-relacoes-e-funcoes-algebricas.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol02-R_ Relações e Funções Algébricas',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol02-R_ relacoes e funcoes algebricas',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '3',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-3/matcol03-r-_-funcoes-de-1o-grau.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol03-R_ Funções de 1º Grau',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol03-R_ funcoes de 1o grau',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '3',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-3/matcol04-r-_-equacao-polinominal-de-2o-grau.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol04-R_ Equação Polinôminal de 2º Grau',
                      book_num: 'Caderno 3',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol04-R_ equacao polinominal de 2o grau',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '3',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-3/matcol17-r-_-geometria-plana.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol17-R_ Geometria Plana',
                      book_num: 'Caderno 3',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol17-R_',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '3',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-3/matcol33-r-_-geometria-espacial.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol33-R_ Geometria Espacial',
                      book_num: 'Caderno 3',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol33-R_ geometria espacial',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '3',
                    },
                  ],
                },
                {
                  bookName: 'Caderno 4',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-4/matcol05-r-_-funcoes-de-2o-grau.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol05-R_ Funções de 2º Grau',
                      book_num: 'Caderno 4',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol05-R_ funcoes de 2o grau',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '4',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-4/matcol06-r-_-funcoes.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol06-R_ Funções',
                      book_num: 'Caderno 4',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol06-R funcoes',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '4',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-4/matcol07-r-_-modulo.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol07-R_ Módulo',
                      book_num: 'Caderno 4',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol07-R modulo',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '4',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-4/matcol34-r-_-geometria-espacial.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol34-R_ Geometria Espacial',
                      book_num: 'Caderno 4',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol34-R geometria espacial',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '4',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-4/matcol35-r-_-geometria-espacial.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol35-R_ Geometria Espacial',
                      book_num: 'Caderno 5',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol35-R_ geometria espacial',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '5',
                    },
                  ],
                },
                {
                  bookName: 'Caderno 5',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-5/matcol08-r-_-exponenciais.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol08-R_ Exponenciais',
                      book_num: 'Caderno 5',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol08-R_ exponenciais',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '5',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-5/matcol09-r-_-logaritmos.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol09-R_ Logaritmos',
                      book_num: 'Caderno 5',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol09-R_ logaritimos',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '5',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-5/matcol38-r-_-geometria-analitica-_-o-ponto.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol38-R_ Geometria Analítica o Ponto',
                      book_num: 'Caderno 5',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol38-R_ geometria analitica o ponto',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '5',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-5/matcol39-r-_-geometria-analitica-_-a-reta.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol39-R_ Geometria Analítica a Reta',
                      book_num: 'Caderno 5',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol39-R_ geometria analitica a reta',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '5',
                    },
                  ],
                },
                {
                  bookName: 'Caderno 6',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-6/matcol24-r-_-sequencias.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol24-R_ Sequências',
                      book_num: 'Caderno 6',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol24-R_ sequencias',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '6',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-6/matcol25-r-_-progressoes-aritmeticas.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol25-R_ Progressões Aritméticas',
                      book_num: 'Caderno 6',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol25-R_ progressoes aritmeticas',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '6',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-6/matcol26-r-_-progressoes-geometricas.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol26-R_ Progressões Geométricas',
                      book_num: 'Caderno 6',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol26-R_ progressoes geometricas',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '6',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-6/matcol46-r-_-geometria-analitica.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol46-R_ Geometria Analítica',
                      book_num: 'Caderno 6',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol46-R_ geometria analitica',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '6',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-6/matfun06-r-_-porcentagem-e-juros.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matfun06-R_ Porcentagem e Juros',
                      book_num: 'Caderno 6',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matfun06-R_ porcentagem e juros',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '6',
                    },
                  ],
                },
                {
                  bookName: 'Caderno 7',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-7/matcol30-r-_-numeros-binomiais-e-binomio-de-newton.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol30-R_ Números Binomiais e Binômio de Newton',
                      book_num: 'Caderno 7',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol30-R_ numeros binomiais e binomio de newton',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '7',
                    },

                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-7/matcol42-r-_-geometria-analitica.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol42-R_ Geometria Analítica',
                      book_num: 'Caderno 7',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol42-R_ geometria analitica',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '7',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-7/matfun07-r-_-estatistica.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matfun07-R_ Matemática Estatística',
                      book_num: 'Caderno 7',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matfun07-R_ matematica estatistica ',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '7',
                    },
                  ],
                },
                {
                  bookName: 'Caderno 8',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-8/matcol18-r-_-trigonometria.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol18-R_ Trigonometria',
                      book_num: 'Caderno 8',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol18-R_ trigonometria',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '8',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-8/matcol23-r-_-relacoes-trigonometricas.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol23-R_ Relações Trigonométricas',
                      book_num: 'Caderno 8',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol23-R_ relacoes trigonometricas',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '8',
                    },

                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-8/matcol27-r-_-matrizes.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol27-R_ Matrizes',
                      book_num: 'Caderno 8',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol27-R_ matrizes',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '8',
                    },

                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-8/matcol28-r-_-determinantes.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol28-R_ Determinantes',
                      book_num: 'Caderno 8',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol28-R_ determinantes',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '8',
                    },

                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-8/matcol29-r-_-sistemas-lineares.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol29-R_ Sistemas Lineares',
                      book_num: 'Caderno 8',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol29-R_ sistemas lineares',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '8',
                    },
                  ],
                },
                {
                  bookName: 'Caderno 9',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-9/matcol19-r-_-aplicando-a-trigonometria.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol19-R_ Aplicando a Trigonometria',
                      book_num: 'Caderno 9',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol19-R_ aplicando a trigonometria',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '9',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-9/matcol31-r-_-analise-combinatoria.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol31-R_ Análise Combinatória',
                      book_num: 'Caderno 9',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol31-R_ analise combinatoria',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '9',
                    },

                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-9/matcol32-r-_-probabilidades.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol32-R_ Probabilidades',
                      book_num: 'Caderno 9',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol32-R_ probabilidades',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '9',
                    },
                  ],
                },
                {
                  bookName: 'Caderno 10',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-10/matcol10-r-_-numeros-complexos-1.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol10-R_ Numeros Complexos',
                      book_num: 'Caderno 10',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol10-R_ numeros complexos',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '10',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-10/matcol11-r-_-polinomios.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol11-R_ Polinômios',
                      book_num: 'Caderno 10',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol11-R_ polinomios',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '10',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-10/matcol12-r-_-equacoes-algebricas-ou-polinomiais.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol12-R_ Equações Algébricas ou Polinomiais',
                      book_num: 'Caderno 10',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol12-R_ equacoes algebricas ou polinomiais',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '10',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/matematica/caderno-10/matcol20-r-_-trigonometria.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: 'E_medio',
                      name: 'matcol20-R_ Trigonometria',
                      book_num: 'Caderno 10',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matcol20-R_ trigonometria',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '10',
                    },
                  ],
                },
              ]
            },
            {
              name: 'Física',
              otherName: '',
              permission: 'segmento-ensino-medio',
              books: [
                {
                  bookName: '',
                  apostila: [
                      {
                        iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                        linkReaOnly: '',
                        linkFree:
                          'ensino-medio/resolucoes/fisica/fiscol01-r-_-cinematica.pdf',
                        videoId: '',
                        src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                        bundle: 'E_medio',
                        name: 'fiscol01-R_ Cinemática',
                        segment: '',
                        discipline: 'Física',
                        description: 'fiscol01-R_ cinematica',
                        toolTip: '',
                        isbn: 'Resoluções',
                      },
                      {
                        iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                        linkReaOnly: '',
                        linkFree:
                          'ensino-medio/resolucoes/fisica/fiscol02-r-_-cinematica.pdf',
                        videoId: '',
                        src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                        bundle: 'E_medio',
                        name: 'fiscol02-R_ Cinemática',
                        segment: '',
                        discipline: 'Física',
                        description: 'fiscol02-R_ cinematica',
                        toolTip: '',
                        isbn: 'Resoluções',
                      },
                      {
                        iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                        linkReaOnly: '',
                        linkFree:
                          'ensino-medio/resolucoes/fisica/fiscol03-r-_-dinamica.pdf',
                        videoId: '',
                        src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                        bundle: 'E_medio',
                        name: 'fiscol03-R_ Dinâmica',
                        segment: '',
                        discipline: 'Física',
                        description: 'fiscol03-R_ dinamica',
                        toolTip: '',
                        isbn: 'Resoluções',
                      },
                      {
                        iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                        linkReaOnly: '',
                        linkFree:
                          'ensino-medio/resolucoes/fisica/fiscol04-r-_-dinamica.pdf',
                        videoId: '',
                        src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                        bundle: 'E_medio',
                        name: 'fiscol04-R_ Dinâmica',
                        segment: '',
                        discipline: 'Física',
                        description: 'fiscol04-R_ dinamica',
                        toolTip: '',
                        isbn: 'Resoluções',
                      },
                      {
                        iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                        linkReaOnly: '',
                        linkFree:
                          'ensino-medio/resolucoes/fisica/fiscol05-r-_-gravitacao-universal.pdf',
                        videoId: '',
                        src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                        bundle: 'E_medio',
                        name: 'fiscol05-R_ Gravitação Universal',
                        segment: '',
                        discipline: 'Física',
                        description: 'fiscol05-R_ gravitacao universal',
                        toolTip: '',
                        isbn: 'Resoluções',
                      },
                      {
                        iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                        linkReaOnly: '',
                        linkFree:
                          'ensino-medio/resolucoes/fisica/fiscol06-r-_-hidrostatica.pdf',
                        videoId: '',
                        src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                        bundle: 'E_medio',
                        name: 'fiscol06-R_ Hidrostática',
                        segment: '',
                        discipline: 'Física',
                        description: 'fiscol06-R_ hidrostatica',
                        toolTip: '',
                        isbn: 'Resoluções',
                      },
                      {
                        iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                        linkReaOnly: '',
                        linkFree:
                          'ensino-medio/resolucoes/fisica/fiscol07-r-_-estatica.pdf',
                        videoId: '',
                        src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                        bundle: 'E_medio',
                        name: 'fiscol07-R_ Estática',
                        segment: '',
                        discipline: 'Física',
                        description: 'fiscol07-R_ estatica',
                        toolTip: '',
                        isbn: 'Resoluções',
                      },
                      {
                        iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                        linkReaOnly: '',
                        linkFree:
                          'ensino-medio/resolucoes/fisica/fiscol08-r-_-termologia-_-calorimetria.pdf',
                        videoId: '',
                        src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                        bundle: 'E_medio',
                        name: 'fiscol08-R_ Termologia',
                        segment: '',
                        discipline: 'Física',
                        description: 'fiscol08-R_ termologia',
                        toolTip: '',
                        isbn: 'Resoluções',
                      },
                      {
                        iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                        linkReaOnly: '',
                        linkFree:
                          'ensino-medio/resolucoes/fisica/fiscol09-r-_-termodinamica.pdf',
                        videoId: '',
                        src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                        bundle: 'E_medio',
                        name: 'fiscol09-R_ Termodinâmica',
                        segment: '',
                        discipline: 'Física',
                        description: 'fiscol09-R_ termodinamica',
                        toolTip: '',
                        isbn: 'Resoluções',
                      },
                      {
                        iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                        linkReaOnly: '',
                        linkFree:
                          'ensino-medio/resolucoes/fisica/fiscol10-r-_-optica.pdf',
                        videoId: '',
                        src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                        bundle: 'E_medio',
                        name: 'fiscol10-R_ Óptica',
                        segment: '',
                        discipline: 'Física',
                        description: 'fiscol10-R_ optica',
                        toolTip: '',
                        isbn: 'Resoluções',
                      },
                      {
                        iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                        linkReaOnly: '',
                        linkFree:
                          'ensino-medio/resolucoes/fisica/fiscol11-r-_-optica.pdf',
                        videoId: '',
                        src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                        bundle: 'E_medio',
                        name: 'fiscol11-R_ Óptica',
                        segment: '',
                        discipline: 'Física',
                        description: 'fiscol11-R_ optica',
                        toolTip: '',
                        isbn: 'Resoluções',
                      },
    
                      {
                        iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/fisica/fiscol12-r-_-eletrodinamica.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                      bundle: 'E_medio',
                      name: 'fiscol12-R_ Eletrodinâmica',
                      segment: '',
                      discipline: 'Física',
                      description: 'fiscol12-R_ eletrodinamica',
                      toolTip: '',
                      isbn: 'Resoluções',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/fisica/fiscol13-r-_-eletrostatica.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                      bundle: 'E_medio',
                      name: 'fiscol13-R_ Eletrostática',
                      segment: '',
                      discipline: 'Física',
                      description: 'fiscol13-R_ eletrostatica',
                      toolTip: '',
                      isbn: 'Resoluções',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/fisica/fiscol14-r-_-eletromagnetismo.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                      bundle: 'E_medio',
                      name: 'fiscol14-R_ Eletromagnetismo',
                      segment: '',
                      discipline: 'Física',
                      description: 'fiscol14-R_ eletromagnetismo',
                      toolTip: '',
                      isbn: 'Resoluções',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/fisica/fiscol15-r-_-ondulatoria.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                      bundle: 'E_medio',
                      name: 'fiscol15-R_ Ondulatória',
                      segment: '',
                      discipline: 'Física',
                      description: 'fiscol15-R_ ondulatoria',
                      toolTip: '',
                      isbn: 'Resoluções',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree:
                        'ensino-medio/resolucoes/fisica/fiscol16-r-_-movimento-harmonico-simples.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                      bundle: 'E_medio',
                      name: 'fiscol16-R_ Movimento Harmônico Simples (MHS)',
                      segment: '',
                      discipline: 'Física',
                      description: 'fiscol16-R_ movimento harmonico simples',
                      toolTip: '',
                      isbn: 'Resoluções',
                    },
                  ]
                }
              ]
            },
            {
              name: 'Química',
              otherName: '',
              permission: 'segmento-ensino-medio',
              books: [
                {
                  bookName: 'Caderno 1',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/quimica/caderno-1/quicol01-r.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-roxo-claro.png',
                      bundle: 'E_medio',
                      name: 'quicol01-R_ Conceitos Fundamentais',
                      book_num: 'Caderno 1',
                      segment: '',
                      discipline: 'Química',
                      description: 'quicol01-R_ conceitos fundamentais',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '1',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/quimica/caderno-1/quicol02-r.pdf',
                      videoId: '',
                      src: 'ensino-medio/resolucoes/quimica/caderno-1/base-roxo-claro.png',
                      bundle: 'E_medio',
                      name: 'quicol02-R_ Substâncias Puras e Misturas',
                      book_num: 'Caderno 1',
                      segment: '',
                      discipline: 'Química',
                      description: 'quicol02-R_ substancias puras e misturas',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '1',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/quimica/caderno-1/quicol03-r.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-roxo-claro.png',
                      bundle: 'E_medio',
                      name: 'quicol03-R_ Estrutura Atômica',
                      book_num: 'Caderno 1',
                      segment: '',
                      discipline: 'Química',
                      description: 'quicol03-R_ estrutura atomica',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '1',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/quimica/caderno-1/quicol04-r.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-roxo-claro.png',
                      bundle: 'E_medio',
                      name: 'quicol04-R_ Classificação Periódica dos Elementos',
                      book_num: 'Caderno 1',
                      segment: '',
                      discipline: 'Química',
                      description: 'quicol04-R_ classificacao periodica dos elementos',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '1',
                    },
                  ]
                },
                {
                  bookName: 'Caderno 2',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/quimica/caderno-2/quicol05-r.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-roxo-claro.png',
                      bundle: 'E_medio',
                      name: 'quicol05-R_ Ligações Químicas',
                      book_num: 'Caderno 2',
                      segment: '',
                      discipline: 'Química',
                      description: 'quicol05-R_ ligacoes quimicas',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '2',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/quimica/caderno-2/quicol06-r.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-roxo-claro.png',
                      bundle: 'E_medio',
                      name: 'quicol06-R_ Polarização Molecular',
                      book_num: 'Caderno 2',
                      segment: '',
                      discipline: 'Química',
                      description: 'quicol06-R_ polarizacao molecular',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '2',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/quimica/caderno-2/quicol07-r.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-roxo-claro.png',
                      bundle: 'E_medio',
                      name: 'quicol07-R_ Atrações Intermoleculares',
                      book_num: 'Caderno 2',
                      segment: '',
                      discipline: 'Química',
                      description: 'quicol07-R_ atracoes intermoleculares',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '2',
                    },
                  ],
                },
                {
                  bookName: 'Caderno 3',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/quimica/caderno-3/quicol08-r.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-roxo-claro.png',
                      bundle: 'E_medio',
                      name: 'quicol08-R_ Funções Inorgânicas',
                      book_num: 'Caderno 3',
                      segment: '',
                      discipline: 'Química',
                      description: 'quicol08-R_ funcoes inorganicas',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '3',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/quimica/caderno-3/quicol09-r.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-roxo-claro.png',
                      bundle: 'E_medio',
                      name: 'quicol09-R_ Reações Químicas',
                      book_num: 'Caderno 3',
                      segment: '',
                      discipline: 'Química',
                      description: 'quicol09-R_ reacoes quimicas',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '3',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/quimica/caderno-3/quicol10-r.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-roxo-claro.png',
                      bundle: 'E_medio',
                      name: 'quicol10-R_ Leis das Reações Químicas',
                      book_num: 'Caderno 3',
                      segment: '',
                      discipline: 'Química',
                      description: 'quicol10-R_ leis das reacoes quimicas',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '3',
                    },
                  ],
                },
                {
                  bookName: 'Caderno 4',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/quimica/caderno-4/quicol11-r.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-roxo-claro.png',
                      bundle: 'E_medio',
                      name: 'quicol11-R_ Massas Atômicas e Moleculares',
                      book_num: 'Caderno 4',
                      segment: '',
                      discipline: 'Química',
                      description: 'quicol11-R_ massas atomicas e moleculares',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '4',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/quimica/caderno-4/quicol13-r.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-roxo-claro.png',
                      bundle: 'E_medio',
                      name: 'quicol13-R_ O Estado Gasoso',
                      book_num: 'Caderno 4',
                      segment: '',
                      discipline: 'Química',
                      description: 'quicol13-R_ o estado gasoso',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '4',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/quimica/caderno-4/quicol14-r.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-roxo-claro.png',
                      bundle: 'E_medio',
                      name: 'quicol14-R_ Cálculos Envolvendo Fórmulas',
                      book_num: 'Caderno 4',
                      segment: '',
                      discipline: 'Química',
                      description: 'quicol14-R_ calculos envolvendo formulas',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '4',
                    },
                  ],
                },
                {
                  bookName: 'Caderno 5',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/quimica/caderno-5/quicol15-r.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-roxo-claro.png',
                      bundle: 'E_medio',
                      name: 'quicol15-R_ Cálculo Estequiométrico',
                      book_num: 'Caderno 5',
                      segment: '',
                      discipline: 'Química',
                      description: 'quicol15-R_ calculo estequiometrico',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '5',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/quimica/caderno-5/quicol16-r.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-roxo-claro.png',
                      bundle: 'E_medio',
                      name: 'quicol16-R_ O Estado Líquido',
                      book_num: 'Caderno 5',
                      segment: '',
                      discipline: 'Química',
                      description: 'quicol16-R_ o estado liquido',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '5',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/quimica/caderno-5/quicol17-r.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-roxo-claro.png',
                      bundle: 'E_medio',
                      name: 'quicol17-R_ Propriedades Coligativas das Soluções',
                      book_num: 'Caderno 5',
                      segment: '',
                      discipline: 'Química',
                      description: 'quicol17-R_ propriedades coligativas das solucoes',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '5',
                    },
                  ],
                },
                {
                  bookName: 'Caderno 6',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/quimica/caderno-6/quicol26-r.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-roxo-claro.png',
                      bundle: 'E_medio',
                      name: 'quicol26-R_ Reações de Oxidorredução',
                      book_num: 'Caderno 6',
                      segment: '',
                      discipline: 'Química',
                      description: 'quicol26-R_ reacoes de oxidorreducao',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '6',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/quimica/caderno-6/quicol27-r.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-roxo-claro.png',
                      bundle: 'E_medio',
                      name: 'quicol27-R_ Eletroquímica',
                      book_num: 'Caderno 6',
                      segment: '',
                      discipline: 'Química',
                      description: 'quicol27-R_ eletroquimica',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '6',
                    },
                  ],
                },
                {
                  bookName: 'Caderno 7',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/quimica/caderno-7/quicol28-r.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-roxo-claro.png',
                      bundle: 'E_medio',
                      name: 'quicol28-R_ Termoquímica',
                      book_num: 'Caderno 7',
                      segment: '',
                      discipline: 'Química',
                      description: 'quicol28-R_ termoquimica',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno',
                      numeral: '7',
                    },
                  ],
                },
                {
                  bookName: 'Caderno 8',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/quimica/caderno-8/quicol21-r.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-roxo-claro.png',
                      bundle: 'E_medio',
                      name: 'quicol21-R_ Cinética Química',
                      book_num: 'Caderno 8',
                      segment: '',
                      discipline: 'Química',
                      description: 'quicol21-R_ cinetica quimica',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '8',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/quimica/caderno-8/quicol22-r.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-roxo-claro.png',
                      bundle: 'E_medio',
                      name: 'quicol22-R_ Equilíbrio Químico',
                      book_num: 'Caderno 8',
                      segment: '',
                      discipline: 'Química',
                      description: 'quicol22-R_ equilibrio quimico',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno',
                      numeral: '8',
                    },
                  ],
                },
                {
                  bookName: 'Caderno 9',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/quimica/caderno-9/quicol18-r.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-roxo-claro.png',
                      bundle: 'E_medio',
                      name: 'quicol18-R_ Radioatividade ',
                      book_num: 'Caderno 9',
                      segment: '',
                      discipline: 'Química',
                      description: 'quicol18-R_ radioatividade',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '9',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/quimica/caderno-9/quicol19-r.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-roxo-claro.png',
                      bundle: 'E_medio',
                      name: 'quicol19-R_ Orgânica',
                      book_num: 'Caderno 9',
                      segment: '',
                      discipline: 'Química',
                      description: 'quicol19-R_ organica',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '9',
                    },
                  ],
                },
                {
                  bookName: 'Caderno 10',
                  apostila: [
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/quimica/caderno-10/quicol23-r.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-roxo-claro.png',
                      bundle: 'E_medio',
                      name: 'quicol23-R_ Orgânica',
                      book_num: 'Caderno 10',
                      segment: '',
                      discipline: 'Química',
                      description: 'quicol23-R_ organica',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '10',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/quimica/caderno-10/quicol24-r.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-roxo-claro.png',
                      bundle: 'E_medio',
                      name: 'quicol24-R_ Reações Orgânicas',
                      book_num: 'Caderno 10',
                      segment: '',
                      discipline: 'Química',
                      description: 'quicol24-R_ reacoes organicas',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '10',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/quimica/caderno-10/quicol25-r.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-roxo-claro.png',
                      bundle: 'E_medio',
                      name: 'quicol25-R_ Ambiental',
                      book_num: 'Caderno 10',
                      segment: '',
                      discipline: 'Química',
                      description: 'quicol25-R_ ambiental',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '10',
                    },
                    {
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkReaOnly: '',
                      linkFree: 'ensino-medio/resolucoes/quimica/caderno-10/quicol30-r.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-roxo-claro.png',
                      bundle: 'E_medio',
                      name: 'quicol30-R_ Substâncias Bio-orgânicas',
                      book_num: 'Caderno 10',
                      segment: '',
                      discipline: 'Química',
                      description: 'quicol30-R_ substancias bio organicas',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '10',
                    },
                  ],
                },
              ]
            },
          ],
        },
        {
          id: 6,
          name: 'Projetos Interdisciplinar',
          iconClass: 'fa-solid fa-book-open fa-sm mr-1',
          link_name: 'ensino-medio-projetos-interdisciplinares',
          colorCard: {
            'background-color': '#fa6d9e',
            'border:': '1px solid #fa6d9e',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-ensino-medio',
          bg__link: 'pre-vestibular',
          books: [
            {
              linkReaOnly: '',
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkFree: 'ensino-medio/projetos-interdisciplinares/projetos-interdisciplinares-em-2019-final.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-roxo-claro.png',
              bundle: 'E_medio',
              name: 'Projetos Interdisciplinares',
              segment: '',
              discipline: '',
              description: '',
              toolTip: '',
              isbn: '',
              numeral: '1',
            },
          ]
        },
        {
          id: 8,
          name: 'Exercícios Regionais',
          iconClass: 'fa-solid fa-earth-americas fa-sm mr-1',
          link_name: 'ensino-medio-exercicios-regionais',
          colorCard: {
            'background-color': '#3b1953',
            'border:': '1px solid #3b1953',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-ensino-medio',
          bg__link: 'banco-questoes',
          turmas: [
            {
              name: 'Minas Gerais',
              otherName: '',
              permission: 'segmento-ensino-medio',
              books: [
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree: 'ensino-medio/exercicios-regionais/minas-gerais/exmgbio0108.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares - Biologia',
                  segment: '',
                  discipline: 'Biologia',
                  description: 'Exercícios Regionais de Vestibulares.',
                  toolTip: '',
                  subname: 'Vestibular',
                  numeral: '',
                  sigla: 'MG',
                  region: 'Minas Gerais',
                  // src_icon: require('../../../assets/images/svg/biologia_roxo.svg'),
                  bg_hover_card: 'casper',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree: 'ensino-medio/exercicios-regionais/minas-gerais/exmgfis0108.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares - Física',
                  segment: '',
                  discipline: 'Física',
                  description: 'Exercícios Regionais de Vestibulares.',
                  toolTip: '',
                  subname: 'Vestibular',
                  numeral: '',
                  sigla: 'MG',
                  region: 'Minas Gerais',
                  // src_icon: require('../../../assets/images/svg/atom.svg'),
                  bg_hover_card: 'white-linen',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree: 'ensino-medio/exercicios-regionais/minas-gerais/exmggeb0108.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares - Geografia do Brasil',
                  segment: '',
                  discipline: 'G. do Brasil',
                  description: 'Exercícios Regionais de Vestibulares',
                  toolTip: '',
                  subname: 'Vestibular',
                  numeral: '',
                  sigla: 'MG',
                  region: 'Minas Gerais',
                  // src_icon: require('../../../assets/images/svg/carbon_globe.svg'),
                  bg_hover_card: 'geyser',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree: 'ensino-medio/exercicios-regionais/minas-gerais/exmggeg0108.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares - Geografia Geral',
                  segment: '',
                  discipline: 'Geografia Geral',
                  description: 'Exercícios Regionais de Vestibulares',
                  toolTip: '',
                  subname: 'Vestibular',
                  numeral: '',
                  sigla: 'MG',
                  region: 'Minas Gerais',
                  // src_icon: require('../../../assets/images/svg/carbon_globe.svg'),
                  bg_hover_card: 'albescent-white',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree: 'ensino-medio/exercicios-regionais/minas-gerais/exmghib0108.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares - História do Brasil',
                  segment: '',
                  discipline: 'História do Brasil',
                  description: 'Exercícios Regionais de Vestibulares',
                  toolTip: '',
                  subname: 'Vestibular',
                  numeral: '',
                  sigla: 'MG',
                  region: 'Minas Gerais',
                  // src_icon: require('../../../assets/images/svg/history.svg'),
                  bg_hover_card: 'albescent-white',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree: 'ensino-medio/exercicios-regionais/minas-gerais/exmghig0108.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares - História Geral',
                  segment: '',
                  discipline: 'História Geral',
                  description: 'Exercícios Regionais de Vestibulares',
                  toolTip: '',
                  subname: 'Vestibular',
                  numeral: '',
                  sigla: 'MG',
                  region: 'Minas Gerais',
                  // src_icon: require('../../../assets/images/svg/history.svg'),
                  bg_hover_card: 'casper',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree: 'ensino-medio/exercicios-regionais/minas-gerais/exmging0108.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares - Língua Inglesa',
                  segment: '',
                  discipline: 'Língua Inglesa',
                  description: 'Exercícios Regionais',
                  toolTip: '',
                  subname: 'Vestibular',
                  numeral: '',
                  sigla: 'MG',
                  region: 'Minas Gerais',
                  // src_icon: require('../../../assets/images/svg/language.svg'),
                  bg_hover_card: 'white-linen',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree: 'ensino-medio/exercicios-regionais/minas-gerais/exmggra0108.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares - Língua Portuguesa',
                  segment: '',
                  discipline: 'Português',
                  description: 'Exercícios Regionais',
                  toolTip: '',
                  subname: 'Vestibular',
                  numeral: '',
                  sigla: 'MG',
                  region: 'Minas Gerais',
                  // src_icon: require('../../../assets/images/svg/LETRAS.svg'),
                  bg_hover_card: 'geyser',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree: 'ensino-medio/exercicios-regionais/minas-gerais/exmglit0108.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares - Língua Portuguesa (Literatura)',
                  segment: '',
                  discipline: 'Português',
                  description: 'Exercícios Regionais • Minas Gerais',
                  toolTip: '',
                  subname: 'Vestibular',
                  numeral: '',
                  sigla: 'MG',
                  region: 'Minas Gerais',
                  // src_icon: require('../../../assets/images/svg/LETRAS.svg'),
                  bg_hover_card: 'casper',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree: 'ensino-medio/exercicios-regionais/minas-gerais/exmgmat0108.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares - Matemática',
                  segment: '',
                  discipline: 'Matemática',
                  description: 'Exercícios Regionais',
                  toolTip: '',
                  subname: 'Vestibular',
                  numeral: '',
                  sigla: 'MG',
                  region: 'Minas Gerais',
                  // src_icon: require('../../../assets/images/svg/matemathics.svg'),
                  bg_hover_card: 'white-linen',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree: 'ensino-medio/exercicios-regionais/minas-gerais/exquimg0108.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares - Química',
                  segment: '',
                  discipline: 'Química',
                  description: 'Exercícios Regionais',
                  toolTip: '',
                  subname: 'Vestibular',
                  numeral: '',
                  sigla: 'MG',
                  region: 'Minas Gerais',
                  // src_icon: require('../../../assets/images/svg/chemical.svg'),
                  bg_hover_card: 'geyser',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree: 'ensino-medio/exercicios-regionais/minas-gerais/exmgred0108.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares - Língua Portuguesa (Redação)',
                  segment: '',
                  discipline: 'Redação',
                  description: 'Exercícios Regionais',
                  toolTip: '',
                  subtitle: 'Vestibular',
                  numeral: '',
                  sigla: 'MG',
                  region: 'Minas Gerais',
                  // src_icon: require('../../../assets/images/svg/LETRAS.svg'),
                  bg_hover_card: 'albescent-white',
                },
              ]
            },
            {
              name: 'Rio de Janeiro',
              otherName: '',
              permission: 'segmento-ensino-medio',
              books: [
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree: 'ensino-medio/exercicios-regionais/rio-de-janeiro/biologia.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares - Biologia',
                  segment: '',
                  discipline: 'Biologia',
                  description: 'Exercícios Regionais de Vestibulares.',
                  toolTip: '',
                  subname: 'Vestibular',
                  numeral: '',
                  sigla: 'RJ',
                  region: 'Rio de Janeiro',
                  // src_icon: require('../../../assets/images/svg/biologia_roxo.svg'),
                  bg_hover_card: 'white-linen',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree: 'ensino-medio/exercicios-regionais/rio-de-janeiro/fisica.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares - Física',
                  segment: '',
                  discipline: 'Física',
                  description: 'Exercícios Regionais de Vestibulares.',
                  toolTip: '',
                  subname: 'Vestibular',
                  numeral: '',
                  sigla: 'RJ',
                  region: 'Rio de Janeiro',
                  // src_icon: require('../../../assets/images/svg/atom.svg'),
                  bg_hover_card: 'casper',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/exercicios-regionais/rio-de-janeiro/geografia-do-brasil.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares - Geografia do Brasil',
                  segment: '',
                  discipline: 'Geografia do Brasil',
                  description: 'Exercícios Regionais de Vestibulares',
                  toolTip: '',
                  subname: 'Vestibular',
                  numeral: '',
                  sigla: 'RJ',
                  region: 'Rio de Janeiro',
                  // src_icon: require('../../../assets/images/svg/carbon_globe.svg'),
                  bg_hover_card: 'white-linen',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree: 'ensino-medio/exercicios-regionais/rio-de-janeiro/geografia-geral.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares - Geografia Geral',
                  segment: '',
                  discipline: 'Geografia Geral',
                  description: 'Exercícios Regionais de Vestibulares',
                  toolTip: '',
                  subname: 'Vestibular',
                  numeral: '',
                  sigla: 'RJ',
                  region: 'Rio de Janeiro',
                  // src_icon: require('../../../assets/images/svg/carbon_globe.svg'),
                  bg_hover_card: 'geyser',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/exercicios-regionais/rio-de-janeiro/historia-do-brasil.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares - História do Brasil',
                  segment: '',
                  discipline: 'História do Brasil',
                  description: 'Exercícios Regionais de Vestibulares',
                  toolTip: '',
                  subname: 'Vestibular',
                  numeral: '',
                  sigla: 'RJ',
                  region: 'Rio de Janeiro',
                  // src_icon: require('../../../assets/images/svg/history.svg'),
                  bg_hover_card: 'casper',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree: 'ensino-medio/exercicios-regionais/rio-de-janeiro/historia-geral.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares - História Geral',
                  segment: '',
                  discipline: 'História Geral',
                  description: 'Exercícios Regionais de Vestibulares',
                  toolTip: '',
                  subname: 'Vestibular',
                  numeral: '',
                  sigla: 'RJ',
                  region: 'Rio de Janeiro',
                  // src_icon: require('../../../assets/images/svg/history.svg'),
                  bg_hover_card: 'white-linen',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree: 'ensino-medio/exercicios-regionais/rio-de-janeiro/ingles.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares - Língua Inglesa',
                  segment: '',
                  discipline: 'Língua Inglesa',
                  description: 'Exercícios Regionais',
                  toolTip: '',
                  subname: 'Vestibular',
                  numeral: '',
                  sigla: 'RJ',
                  region: 'Rio de Janeiro',
                  // src_icon: require('../../../assets/images/svg/language.svg'),
                  bg_hover_card: 'geyser',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree: 'ensino-medio/exercicios-regionais/rio-de-janeiro/gramatica.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares Língua Portuguesa (Gramática)',
                  segment: '',
                  discipline: 'Português',
                  description: 'Exercícios Regionais',
                  toolTip: '',
                  subname: 'Vestibular',
                  numeral: '',
                  sigla: 'RJ',
                  region: 'Rio de Janeiro',
                  // src_icon: require('../../../assets/images/svg/LETRAS.svg'),
                  bg_hover_card: 'albescent-white',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree: 'ensino-medio/exercicios-regionais/rio-de-janeiro/literatura.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares Língua Portuguesa (Literatura)',
                  segment: '',
                  discipline: 'Português',
                  description: 'Exercícios Regionais',
                  toolTip: '',
                  subname: 'Vestibular',
                  numeral: '',
                  sigla: 'RJ',
                  region: 'Rio de Janeiro',
                  // src_icon: require('../../../assets/images/svg/LETRAS.svg'),
                  bg_hover_card: 'albescent-white',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree: 'ensino-medio/exercicios-regionais/rio-de-janeiro/matematica.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares - Matemática',
                  segment: '',
                  discipline: 'Matemática',
                  description: 'Exercícios Regionais',
                  toolTip: '',
                  subname: 'Vestibular',
                  numeral: '',
                  sigla: 'RJ',
                  region: 'Rio de Janeiro',
                  // src_icon: require('../../../assets/images/svg/matemathics.svg'),
                  bg_hover_card: 'casper',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree: 'ensino-medio/exercicios-regionais/rio-de-janeiro/quimica.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares - Química',
                  segment: '',
                  discipline: 'Química',
                  description: 'Exercícios Regionais',
                  toolTip: '',
                  subname: 'Vestibular',
                  numeral: '',
                  sigla: 'RG',
                  region: 'Rio de Janeiro',
                  // src_icon: require('../../../assets/images/svg/chemical.svg'),
                  bg_hover_card: 'white-linen',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree: 'ensino-medio/exercicios-regionais/rio-de-janeiro/redacao.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares - Língua Portuguesa (Redação)',
                  segment: '',
                  discipline: 'Redação',
                  description: 'Exercícios Regionais',
                  toolTip: '',
                  subname: 'Vestibular',
                  numeral: '',
                  sigla: 'RJ',
                  region: 'Rio de Janeiro',
                  // src_icon: require('../../../assets/images/svg/LETRAS.svg'),
                  bg_hover_card: 'geyser',
                },
              ]
            },
            {
              name: 'Sul',
              otherName: '',
              permission: 'segmento-ensino-medio',
              books: [
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/exercicios-regionais/sul/exercicios-regiao-sul-caderno-1.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares - Caderno 1 (Geral)',
                  segment: '',
                  discipline: 'Todas as Matérias',
                  description: 'Exercícios Regionais • SUL',
                  toolTip: '',
                  subname: 'Vestibular - Caderno 1',
                  numeral: '',
                  sigla: 'Sul',
                  region: 'Sul',
                  // src_icon: require('../../../assets/images/svg/caderno.svg'),
                  bg_hover_card: 'casper',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/exercicios-regionais/sul/exercicios-regiao-sul-caderno-2.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares - Caderno 2 (Geral)',
                  segment: '',
                  discipline: 'Todas as Matérias',
                  description: 'Exercícios Regionais • SUL',
                  toolTip: '',
                  subname: 'Vestibular - Caderno 2',
                  numeral: '',
                  sigla: 'Sul',
                  region: 'Sul',
                  // src_icon: require('../../../assets/images/svg/caderno.svg'),
                  bg_hover_card: 'white-linen',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/exercicios-regionais/sul/exercicios-regiao-sul-caderno-3.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares - Caderno 3 (Geral)',
                  segment: '',
                  discipline: 'Todas as Matérias',
                  description: 'Exercícios Regionais • SUL',
                  toolTip: '',
                  subname: 'Vestibular - Caderno 3',
                  numeral: '',
                  sigla: 'Sul',
                  region: 'Sul',
                  // src_icon: require('../../../assets/images/svg/caderno.svg'),
                  bg_hover_card: 'geyser',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'ensino-medio/exercicios-regionais/sul/exercicios-regiao-sul-caderno-4.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Exercícios de Vestibulares - Caderno 4 (Geral)',
                  segment: '',
                  discipline: 'Todas as Matérias',
                  description: 'Exercícios Regionais • SUL',
                  toolTip: '',
                  subname: 'Vestibular - Caderno 4',
                  numeral: '',
                  sigla: 'Sul',
                  region: 'Sul',
                  // src_icon: require('../../../assets/images/svg/caderno.svg'),
                  bg_hover_card: 'albescent-white',
                },
              ]
            },
          ],
        },
      ],
    };
  },

  created() {
    this.$emit('update-header', {
      title: this.pageTitle,
      subtitle: this.pageSubtitle,
    });
  },

  computed: {
    permissions() {
      return this.$store.state.auth.userpermissions.permissions;
    },
    error503() {
      return (window.location.href = '/nao-autorizado');
    },
  },

  methods: {
    hasPermission(permission) {
      return this.permissions.includes(permission);
    },

    setActive(index) {
      this.activeIndex = index;
    },

    clearActive(index) {
      if (this.activeIndex === index) {
        this.activeIndex = null;
      }
    },

    toggleCollapse(type, idx) {
      if (!Array.isArray(this.collapsedStates[type])) {
        this.$set(this.collapseStates, type, [])
      }

      this.collapsedStates[type].forEach((_, index) => {
        this.$set(this.collapsedStates[type], index, index === idx ? !this.collapsedStates[type][idx] : false)
      });
    },

    formatParam(param) {
      return param.replace(/\s+/g, '-');
    },

    getVisibleBooks(turma) {
      if (!turma || !turma.books) {
        return [];
      }
      return turma.books.filter(book => book.bookName && book.bookName.trim() !== '');
    }
  },
};
</script>

<style scoped>
.nav-books {
  padding: 0.5rem 0.5rem;
}

.nav-books span {
  color: #3A1C53;
}

.nav-books i {
  color: #E98B24;
}

.card_sistemacpv {
  border-radius: 8px;
  color: #3A1C53;
}

.button-toggle {
  background-color: rgba(248, 249, 250, 0.45);
}
.button-toggle span strong {
  color: #3A1C53;
}

.button-toggle i {
  color: #E98B24;
}
.border-bottom {
  border-color: 1px solid #dee2e6 !important;
}

.title-collapse {
  color: #3A1C53;
}

.nav-cadernos {
  color: #3a1c53;
  font-weight: 600;
  padding: 0.5rem 0.5rem;
}

.nav-cadernos.active {
  color: #E98B24 !important;
}
</style>
